import React from "react";
import "../css/delivery.scss";

function Delivery() {
  return <main id="main" className="main"><div className="shopify-policy__container">
    <div className="shopify-policy__title"><h1>Shipping policy</h1></div>
    <div className="shopify-policy__body"><div className="rte">
      <p>Last updated: September 14, 2026</p>
      <h2>Order processing</h2>
      <p>Orders are prepared after payment is confirmed. Any processing estimate shown at checkout is separate from carrier transit time. During unusually busy periods, preparation may take longer.</p>
      <h2>Shipping rates and estimates</h2>
      <p>Available methods, charges, and estimated delivery windows are shown at checkout for the destination entered. Estimates are not guaranteed and may be affected by carrier, customs, weather, or local service disruptions.</p>
      <h2>Address changes</h2>
      <p>Contact us as soon as possible if an address is wrong. We cannot promise a change after packing or dispatch, and customers are responsible for providing a complete, deliverable address.</p>
      <h2>Customs and import charges</h2>
      <p>Unless checkout expressly states that import charges are included, the recipient is responsible for duties, taxes, brokerage, and other destination charges.</p>
      <h2>Tracking, delay, and failed delivery</h2>
      <p>Tracking is supplied when available. If a parcel is delayed, refused, unclaimed, or returned because of an incorrect address or unpaid destination charge, any refund or reshipment will be assessed after recoverable costs and the condition of returned goods are known.</p>
      <h2>Damage or loss</h2>
      <p>Contact us promptly with the order number, packaging photos, and item photos if a parcel arrives damaged or incomplete. Keep all packaging while the carrier review is open.</p>
      <h2>Contact</h2>
      <p>Email <a href="mailto:phase@slayfulpawsco.cloud">phase@slayfulpawsco.cloud</a> for shipping help.</p>
      <p>Mail: Forest Inc., 390 Lofton Rd NW, Atlanta, GA 30309 US</p>
    </div></div>
  </div></main>;
}

export default Delivery;
